let api = {};

const pre_v1 = '/api/v1';
const pre_v5 = "/api/clearflow-service";
const pre_w1 = "/api/w1";

// 登录
api.login = '/api/login';

// 配置项
api.configType = pre_v1+'/config/type';

//充电桩型号
api.pileType = pre_v1 + '/piletype';

// 注册
api.register = {
    // 获取验证码
    // getCode: '/api/v1/app/cust/sendCode', // 弃用
    // getCode: '/api/v1/app/cust/sendEncodeCode',
    getCode: '/api/v1/app/cust/sendCode2',

    // 核对验证码
    checkMessage: '/api/v1/app/cust/checkCode',
    // 提交信息
    addAccountForm: '/api/v1/dealer/addClearingAccount',
    // 详情
    detailAccountForm: '/api/v1/dealer/getClearingAccountInfoById',
};

// 区域省市区
api.areaList = pre_v1+'/area?pageNum=0&pageSize=9999';
// user
api.user = {
    list: pre_v1 + '/user',
    supplierusercheck: pre_v1 + '/user',
    currentUserInfo: pre_v1 + '/user/info/current',//获取当前用户信息
    userPwdReset:  pre_v1 + '/user/userPwdReset'
};

api.menu = {
    allList: pre_v1 +'/menu/list',
}
// role
api.role = {
    list: pre_v1 + '/role',
    listmenu: pre_v1 + '/role/listmenu',
    allrole: pre_v1 + '/role/list'
};

api.config = {
    list: '/api/v1/config/list',
    config: '/api/v1/config',
}

//仪表盘
api.dashboard = {
    pileandorderdto : pre_v1 + '/dashboard/pileandorderdto',
    leftorderdto : pre_v1 + '/dashboard/leftorderdto',
    dayorderdto : pre_v1 + '/dashboard/dayorderdto',
    monthtrend : pre_v1 + '/dashboard/monthtrend',
    daytrend : pre_v1 + '/dashboard/daytrend',
    middlestations : pre_v1 + '/dashboard/middlestations'
}

//充电桩
api.pile = {
    list: pre_v1 + '/pile',
    pile: pre_v1 + '/pile/pilepage',
    //充电记录
    pileorder:pre_v1 + '/pileorder',
    //维修
    pilerepair:pre_v1 + '/pilerepair',
    //用户反馈列表
    findByNo: pre_v1 + '/pilerepair/findByNo',
    //故障记录
    pileWarn:'/api/m1/pileWarn/page',
    //故障备注
    warn:'/api/m1/pileWarn/edit',
    dealer:'/api/v1/dealer/list',
    findByDealNo: '/api/v1/dealer/findByDealNo',
    type:'/api/v1/piletype/list',
    pileCharge:"/api/v1/pilecharge/list",
    findByPileCode:pre_v1 + '/pile/findByPileCode',
    //解绑
    unBindPile: pre_v1 + '/app/custpile/unBindPile',
    updatePileDetail: pre_v1 + '/pile/updatePileDetail',
    findById: pre_v1 + '/pile/findById',
    exportPile: pre_v1 + '/pile/exportPile',
    findPileCodeList: pre_v1 + '/pile/findPileCodeList'
}

//充电站
api.pilestation = {
    pilestation:pre_v1 + '/pilestation',
    rpt:pre_v1 + '/pilestation/rpt',
    findno:pre_v1 + '/pilecharge/findno',
    //根据充电网点找出的充电记录
    record:'/api/v1/pilestation/dealerstrategyrecord',
    //根据充电网点找出的账单
    bill:"/api/v1/pilestation/exportbillpdf",
    //导出
    export:"/api/v1/pilestation/exportbill",
    addpile:pre_v1+'/pilestation/addpiletostation',
    delpile:pre_v1+'/pilestation/deleteppilefromstation',
    delAppImg:pre_v1+'/pilestation/deleteappimgs',
    pilelist:pre_v1 + '/pile/list',
    //资费编辑
    pilecharge: pre_v1 + '/pilecharge',
    rptfrom: pre_v1 + '/pilestation/rptfrom',
    rptchart: pre_v1 + '/pilestation/rptchart',

    chaegeExpense: pre_v1 + '/postageDetail/chaegeExpense',
    findChargePileTypeNo: pre_v1 + '/pilecharge/findChargePileTypeNo',
    
    updateCustomize: pre_v1 + '/pilecharge/updateCustomize', // 资费策略 - 保存
    findNoOrStationCode: pre_v1 + '/pilecharge/findNoOrStationCode', // 资费策略 - 详情

    energyConfig: pre_v1 + '/v2gStationEnergyStrategy/energyConfig', // 补能策略 - 保存
    findValley: pre_v1 + '/v2gStationEnergyStrategy/findValley', // 补能策略 - 详情
    findValleyInfo: pre_v1 + '/v2gStationEnergyStrategy/findValleyInfo', // 补能策略 - 详情
    saveValley: pre_v1 + '/v2gStationEnergyStrategy/saveValley', // 补能策略 - 详情 - 提交
    valleyPage: pre_v1 + '/mongo/ocpprecord/valleyPage', // 补能策略 - 详情 - 列表
    valleyList: pre_v1 + '/pilecharge/findValley', // 平谷时段查询

    reSendCmd:pre_v1 +'/mongo/ocpprecord/reSendCmd',

    feedNetConfig: pre_v1 + '/v2gStationEnergyStrategy/feedNetConfig', // 馈网策略 - 保存
    findPeak: pre_v1 + '/v2gStationEnergyStrategy/findPeak', // 馈网策略 - 详情
    findPeakInfo: pre_v1 + '/v2gStationEnergyStrategy/findPeakInfo', // 馈网策略 - 详情
    savePeak: pre_v1 + '/v2gStationEnergyStrategy/savePeak', // 馈网策略 - 详情 - 提交
    peakPage: pre_v1 + '/mongo/ocpprecord/peakPage', // 馈网策略 - 详情 - 列表
    peakList: pre_v1 + '/pilecharge/findPeak', // 尖峰时段查询


}

//客户管理
api.cust = {
    pagecust:pre_v1 + '/cust/pagecust',
    cust:pre_v1 + '/cust/findbyid',
    addupdatecust:pre_v1 + '/cust/addupdatecust',
    targetremark:pre_v1 + '/cust/targetremark',
    addtarget:'/api/v1/cust/addtarget',
    custwalletlist: pre_v1 +'/custwalletlist',
    chargeCardList: pre_v1 +'/chargeCardList',
    addWalletList: pre_v1 + '/custwalletlist/addWalletList',
    allDealer:pre_v1 +'/dealer',
    //充值退款
    addCardList: pre_v1 + '/chargeCardList/addCardList',
    exportCustList: pre_v1 + '/cust/exportCustList',
    findCustPhoneList: pre_v1 + '/cust/findCustPhoneList'
}
//订单管理
api.order = {
    pileorder:pre_v1 + '/pileorder',
    dealorderreply:pre_v1 + '/pileOrderReply/dealorderreply',
    updatechargestep:pre_v1 + '/pileorder/updatechargestep',
    updateRemark: pre_v1 + '/pileorder/updateRemark',
    exportOrderList: pre_v1 + '/pileorder/exportOrderList',

    // 表单流程数据 
    orderPhase: pre_v1 + '/pileorder/phase/stats/',
}
//运营商管理
api.dealer = {
    dealer : pre_v1 + '/dealer',
    allList: pre_v1 + "/dealer/list",
    addbank : pre_v1 + '/dealer/addbank',
    editbank : pre_v1 + '/dealer/editbank',
    editattach : pre_v1 + '/dealer/editattach',
    removeattach : pre_v1 + '/dealer/removeattach',
    addattach : pre_v1 + '/dealer/addattach',
    addpiletostation : pre_v1 + '/pilestation/addpiletostation',
    updstation : pre_v1 + '/dealer/updstation',
    edit : pre_v1 + '/dealer/edit',
    rptchart : pre_v1 + '/dealer/rptchart',
    rpt : pre_v1 + '/dealer/rpt',
    rptinfo: pre_v1 + '/dealer/rptinfo',
    custlinedata: pre_v1 + '/cust/findByCreateTime',
    rptform : pre_v1 + '/dealer/rptform',
    getDealList : pre_v1 + '/dealer/getDealList',
}
//财务管理
api.finance = {
    calcpage: pre_v1 + '/dealer/calcpage',
    revieworders : pre_v1 + '/pileorder/revieworders',
    checkorders: pre_v1 + '/pileorder/checkorders',
    cashOut: pre_v1 + '/cashOut/findCashList',
    addCashOut: pre_v1 + '/cashOut/addCashOut',
    chargeCard: pre_v1 + '/chargeCard',
    addCard: pre_v1 + '/chargeCard/addCard',
    powerStationStatement: pre_v1 + '/dealer/powerStationStatement',
}
//服务记录
api.feedback = {
    serviceFeedback: pre_v1 + '/serviceFeedback',
}
// 运营结算
api.operatorSettlement={
    // 导出
    dtoListSummaryExport:pre_v1 + '/pileorder/dtoListSummaryExport',
    // 查询
    getDtoListSummary:pre_v1+'/pileorder/getDtoListSummary',
    // 运营商
    getDealList:'/api/v1/dealer/getDealList',
    // 站点
    list:'/api/v1/pilestation/list',
    getDtoPageInfo: pre_v1 + "/pileorder/getDtoPageInfo",
}

api.logout = {
    logout :pre_v1 +'/logout'
}

// 清分结算
api.cleanSettleRecord = {
    // 结算总表 - 分页列表数据
    list: pre_v5 + '/web/dealerPayoutRecords/page',
    // 结算总表 - 通过运营商 查询 结算商户、结算站点
    getOptions: pre_v5 + '/web/receiveAccount/findByDealerId/',
    // 结算总表 - 结算统计
    sumInfo: pre_v5 + '/web/pileOrderReceiveAccountSplit/settlementSummary',
    // 结算总表 - 提交发票结算
    submitSettle: pre_v5 + '/web/orderSplitSettlementRecord/settle',
    // 结算总表 - 列表 - 提交发票
    submitInvoice: pre_v5 + '/web/dealerPayoutRecords/commitInvoice',
    // 结算总表 - 列表 - 审核发票
    examineInvoice: pre_v5 + '/web/dealerPayoutRecords/verifyInvoice',
    // 结算总表 - 结算订单详表 - 根据站点 查询结算单号
    getPayOrderList: pre_v5 + '/web/dealerPayoutRecords/listPayoutRecordNo',
    // 结算总表 - 结算订单详表 - 结算数据
    getPaySettlementList: pre_v5 + '/web/dealerPayoutRecords/getSettlementPileOrderDetail',
    // 结算总表 - 结算订单详表 - 表格数据 - 数据详情
    getPayOrderTableDetail: pre_v5 + '/web/dealerPayoutRecords/findSettlementPileOrder',

    // 结算总表 - 相似订单 - 查询条件
    getHeadSearchInfo: pre_v5 + '/web/dealerPayoutRecords/getPayoutMerchantDetail',

    // 结算总表 - 列表 - 上传发票
    uploadInvoice: pre_v5 + '/web/file/uploadFile',
    // 结算总表 - 列表 - 发票信息
    imgInvoicePath: pre_v5 + '/web/file/getDownloadUrl',

    // 清分结算 - 清分账户 - 列表
    accountList: pre_v5 + '/web/receiveAccount/findListPage',
    // 清分结算 - 清分账户 - 新增
    addAccount: pre_v5 + '/web/receiveAccount/confirmAndCreate',
    // 清分结算 - 清分账户 - 详情
    accountDetail: pre_v5 + '/web/receiveAccount/findById/',
    // 清分结算 - 清分账户 - 编辑 - 新站站点 - 根据站点编号查询 清分信息
    getClearAccountInfo: pre_v5 + '/web/receiveAccountStationSplitConfig/findById/',
    // 清分结算 - 清分账户 - 编辑 - 新站站点 - 添加
    addClearAccountInfo: pre_v5 + '/web/receiveAccountStationSplitConfig/commit',
    // 清分结算 - 清分账户 - 编辑 - 新站站点 - 添加 - 选择站点查询公司信息
    getCompanyInfo: pre_v5 + '/web/receiveAccountStationSplitConfig/findStationCurrentSplitSituation/',
    // 清分结算 - 清分账户 - 编辑 - 新站站点 - 添加 - 选择根据运营商查询站点信息
    getStationList: pre_v5 + '/web/pileStation/findByDealNo/',


    
}

// 系统设置
api.sysConfig = {
    // 操作日志 - 列表数据
    logList: pre_v1 + '/operateLog/list',
    // 操作日志 - 导出
    logExport: pre_v1 + '/operateLog/export',
}

export default api;
